import { EmptyAction, DataAction, ErrorAction } from './utils';
import { Document } from '../../models/document';
import { Truck } from '../../models/truck';

export enum ActionType {
  SAVE_DOCUMENT_REQUEST = 'SAVE_DOCUMENT/REQUEST',
  SAVE_DOCUMENT_SUCCESS = 'SAVE_DOCUMENT/SUCCESS',
  SAVE_DOCUMENT_FAILURE = 'SAVE_DOCUMENT/FAILURE',

  UPLOAD_DOCUMENT_REQUEST = 'UPLOAD_DOCUMENT/REQUEST',
  UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT/SUCCESS',
  UPLOAD_DOCUMENT_FAILURE = 'UPLOAD_DOCUMENT/FAILURE',
}

export type SaveDocumentRequestAction = DataAction<ActionType.SAVE_DOCUMENT_REQUEST, Document>;
export type SaveDocumentSuccessAction = EmptyAction<ActionType.SAVE_DOCUMENT_SUCCESS>;
export type SaveDocumentFailureAction = ErrorAction<ActionType.SAVE_DOCUMENT_FAILURE>;

export type SaveDocumentAction =
  SaveDocumentRequestAction |
  SaveDocumentSuccessAction |
  SaveDocumentFailureAction;

export type UploadDocumentRequestAction =
  DataAction<ActionType.UPLOAD_DOCUMENT_REQUEST, { document: Document; truck: Truck; }>;
export type UploadDocumentSuccessAction =
  DataAction<ActionType.UPLOAD_DOCUMENT_SUCCESS, { document: Document; truck: Truck; }>;
export type UploadDocumentFailureAction =
  ErrorAction<ActionType.UPLOAD_DOCUMENT_FAILURE, { document: Document; truck: Truck; }>;

export type UploadDocumentAction =
  UploadDocumentRequestAction |
  UploadDocumentSuccessAction |
  UploadDocumentFailureAction;

export type Action =
  SaveDocumentAction | UploadDocumentAction;

export const saveDocument = {
  request: (data: Document): SaveDocumentRequestAction => ({
    data,
    type: ActionType.SAVE_DOCUMENT_REQUEST,
  }),
  success: (): SaveDocumentSuccessAction => ({
    type: ActionType.SAVE_DOCUMENT_SUCCESS,
  }),
  failure: (error: string): SaveDocumentFailureAction => ({
    error,
    type: ActionType.SAVE_DOCUMENT_FAILURE,
  }),
};

export const uploadDocument = {
  request: (truck: Truck, document: Document): UploadDocumentRequestAction => ({
    data: { truck, document },
    type: ActionType.UPLOAD_DOCUMENT_REQUEST,
  }),
  success: (truck: Truck, document: Document): UploadDocumentSuccessAction => ({
    data: { truck, document },
    type: ActionType.UPLOAD_DOCUMENT_SUCCESS,
  }),
  failure: (error: string, truck: Truck, document: Document): UploadDocumentFailureAction => ({
    error,
    data: { truck, document },
    type: ActionType.UPLOAD_DOCUMENT_FAILURE,
  }),
};
